import { useState } from "react";
import InsertEmployeeModal from "../modals/InsertEmployee";
import EditEmployeeModal from "../modals/EditEmployee";
import { Page, DataTable } from "@iq/models";
import { FiPlus } from "react-icons/fi";

const EMPLOYEE_TABLE_CONFIG = {
    columns: [
        { 
            key: "name", 
            label: "Name", 
            accessor: (row) => row?.name || "-", 
            filterable: true,
            quickValues: ["A–E", "F–J", "K–O", "P–T", "U–Z"]
        },
        { 
            key: "email", 
            label: "Email", 
            accessor: (row) => row?.email || "-", 
            filterable: false 
        },
        { 
            key: "role", 
            label: "Role", 
            accessor: (row) => row?.role || row?.job_title || row?.title || "-", 
            filterable: true,
            quickValues: ["Admin", "Member", "Supreme"]
        },
        { 
            key: "department", 
            label: "Department", 
            accessor: (row) => row?.department || "-", 
            filterable: false
        },
        { 
            key: "status", 
            label: "Status", 
            accessor: (row) => row?.status || "-", 
            filterable: true,
            quickValues: ["Active", "Inactive"]
        },
    ],
};

function Employees({ employees = [], loading = false, error = "", onEmployeeInserted }) {
    const rows = Array.isArray(employees) ? employees : [];
    const [showInsertEmployeeModal, setShowInsertEmployeeModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    function handleCloseInsertEmployee() {
        setShowInsertEmployeeModal(false);
        onEmployeeInserted?.();
    }

    function handleRowClick(employee) {
        setSelectedEmployee(employee);
    }

    return (
        <Page>
            {error ? (
                <div className="form-error-message" role="alert" style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                    <span>{error}</span>
                    <button type="button" onClick={onEmployeeInserted}>Retry</button>
                </div>
            ) : null}

            <div>
                <DataTable
                    rowData={rows}
                    loading={loading}
                    tableConfig={EMPLOYEE_TABLE_CONFIG}
                    onRowClick={handleRowClick}
                />

                <button
                    type="button"
                    onClick={() => setShowInsertEmployeeModal(true)}
                    aria-label="Insert employee"
                    style={{
                        position: "absolute",
                        right: "var(--space-6)",
                        bottom: "var(--space-6)",
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        backgroundColor: "var(--color-highlight)",
                        color: "var(--color-bg-page)",
                        fontSize: "1.6rem",
                        lineHeight: 1,
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "var(--shadow-sm)",
                    }}
                >
                    <FiPlus size={24} />
                </button>
            </div>

            {showInsertEmployeeModal && (
                <InsertEmployeeModal
                    onClose={() => setShowInsertEmployeeModal(false)}
                    onInserted={handleCloseInsertEmployee}
                />
            )}

            {selectedEmployee ? (
                <EditEmployeeModal
                    employee={selectedEmployee}
                    onClose={() => setSelectedEmployee(null)}
                    onInserted={() => {
                        setSelectedEmployee(null);
                        onEmployeeInserted?.();
                    }}
                />
            ) : null}
        </Page>
    );
}

export default Employees;